(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.OttuniPreorder = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  function requestedPayment(search) {
    var params = new URLSearchParams(search || '');
    var payment = params.get('payment');

    if (payment === 'reserve' || payment === 'full') {
      return payment;
    }

    return null;
  }

  function selectPaymentOption(root, search) {
    var payment = requestedPayment(search);
    if (!root || !payment) return false;

    var selector =
      '[data-payment-key="' +
      payment +
      '"] input[type="radio"]';
    var radio = root.querySelector(selector);

    if (!radio || radio.disabled) return false;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  return {
    requestedPayment: requestedPayment,
    selectPaymentOption: selectPaymentOption,
  };
});
